<template>
  <label class="theme-switch">
    <input 
      type="checkbox" 
      v-model="isDarkMode" 
      @change="handleSwitch"
      class="switch-input"
    >
    <span class="switch-track">
      <span class="switch-thumb">
        <span class="thumb-icon" :class="{ dark: isDarkMode }">
          <svg class="sun" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
          </svg>
          <svg class="moon" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        </span>
      </span>
    </span>
    <span class="switch-label" v-if="showLabel">
      {{ isDarkMode ? 'Dark' : 'Light' }}
    </span>
  </label>
</template>

<script>
export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isDarkMode: false,
      // 存储 highlight 样式链接元素，方便后续移除
      highlightLink: null
    };
  },
  mounted() {
    // 1. 初始化明暗模式
    const savedMode = localStorage.getItem('darkMode');
    this.isDarkMode = savedMode === 'true';
    this.updateHtmlClass(this.isDarkMode);
    
    // 2. 加载对应 highlight 样式
    this.loadHighlightStyle(this.isDarkMode);
  },
  methods: {
    handleSwitch() {
      // 1. 保存模式到本地存储
      localStorage.setItem('darkMode', this.isDarkMode);
      // 2. 更新页面根元素类名
      this.updateHtmlClass(this.isDarkMode);
      // 3. 切换 highlight 样式
      this.loadHighlightStyle(this.isDarkMode);
    },
    updateHtmlClass(isDark) {
      const html = document.documentElement;
      isDark ? html.classList.add('dark-mode') : html.classList.remove('dark-mode');
    },
    loadHighlightStyle(isDark) {
      // 1. 移除已存在的 highlight 样式（避免冲突）
      if (this.highlightLink) {
        document.head.removeChild(this.highlightLink);
      }
      
      // 2. 创建新的 CSS 链接元素
      this.highlightLink = document.createElement('link');
      this.highlightLink.rel = 'stylesheet';
      this.highlightLink.type = 'text/css';
      
      // // 3. 根据模式设置样式文件路径
      // this.highlightLink.href = isDark 
      //   ? 'https://cdn.jsdelivr.net/npm/highlight.js@11.9.0/styles/atom-one-dark.css' 
      //   : 'https://cdn.jsdelivr.net/npm/highlight.js@11.9.0/styles/atom-one-light.css';
      this.highlightLink.href = isDark 
        ? './assets/css/highlight/atom-one-dark.css'  // 暗黑模式本地路径
        : './assets/css/highlight/atom-one-light.css'; // 亮色模式本地路径
      
      // 4. 将链接插入页面头部
      document.head.appendChild(this.highlightLink);
    }
  }
};
</script>

<style scoped>
/* 原有样式不变，此处省略 */
.theme-switch {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  padding: 2px 0;
}
.switch-input { display: none; }
.switch-track {
  position: relative;
  width: 50px;
  height: 20px;
  border-radius: 14px;
  background: var(--switch-bg);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}
.switch-input:checked + .switch-track { background: var(--switch-bg); }
.switch-thumb {
  position: absolute;
  top: 0px;
  left: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--switch-thumb);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.switch-input:checked + .switch-track .switch-thumb { transform: translateX(26px); }
.thumb-icon {
  position: relative;
  width: 14px;
  height: 14px;
  color: var(--switch-color);
}
.sun, .moon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.sun { opacity: 1; transform: scale(1); }
.moon { opacity: 0; transform: scale(0.8); }
.thumb-icon.dark .sun { opacity: 0; transform: scale(0.8); }
.thumb-icon.dark .moon { opacity: 1; transform: scale(1); }
.switch-label {
  font-size: 14px;
  color: var(--switch-color);
  transition: color 0.3s ease;
}
.theme-switch:hover .switch-label { color: var(--btn-color); }
.switch-input:active + .switch-track .switch-thumb { transform: scale(0.95); }
.switch-input:checked:active + .switch-track .switch-thumb { transform: translateX(26px) scale(0.95); }
</style>